'use strict';

var React = require('react');

var SvgColumn1Major = function SvgColumn1Major(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 2h-12v16h12v-16Zm-12-2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-16a2 2 0 0 0-2-2h-12Z"
  }));
};

exports.SvgColumn1Major = SvgColumn1Major;
